export default __webpack_public_path__ + "static/malaysia-b16f8be078aa07168cae8c4bac4fe96e.svg";